import React, {useState} from "react";
import {SketchPicker} from 'react-color';
import {DeleteButton} from "./DeleteButton";
import "./ColorInput.scss";

export const ColorInput = ({property}) => {
    const [, forceUpdate] = useState();
    const [open, setOpen] = useState(false);
    const color = property.get();
    return (
        <div className="color-input flex-row">
            {open
                ? (
                    <React.Fragment>
                        <SketchPicker
                            width={160}
                            presetColors={[]}
                            disableAlpha={true}
                            color={color ?? '#ffffff'}
                            onChangeComplete={value => {
                                forceUpdate(property.set(value.hex));
                                APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
                            }}
                        />
                        <div className="button"
                             onClick={() => setOpen(false)}>
                            ◀
                        </div>
                    </React.Fragment>
                )
                : (
                    color == null
                        ? (
                            <div className="color button"
                                 onClick={() => setOpen(true)}>
                                keine
                            </div>)
                        : (
                            <React.Fragment>
                                <div className="color button"
                                     style={{backgroundColor: color ?? 'transparent'}}
                                     onClick={() => setOpen(true)}>
                                </div>
                                <div className="color button"
                                     onClick={() => setOpen(true)}>&nbsp;{color}</div>
                                <DeleteButton property={property}/>
                            </React.Fragment>)
                )
            }
        </div>
    );
}

